import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import ClipLoader from "react-spinners/ClipLoader"
import { confirmAlert } from "react-confirm-alert"
import toast from "react-hot-toast"
import moment from "moment/moment"
import { deleteCanteenUser, getCanteenUser, getCanteenUserProfile, getTranslationWithPageName, saveCanteenUser, searchColleague, } from "../../services/ApiServices"
import { changeUserTranslationValue } from "../../store/slices/TranslationSlice.ts"
import { convertRespArrToLabelObject, getDynamicLabel } from "../../utils/helpers"
import { changeAllCanteenUsersValue } from "../../store/slices/APIResponseSlice"
import { PAGE_NAME } from "../../utils/pageName.ts"
import { appName, handleError } from "../../const"

// ==== Imported Image ====
import iconUser from "../../assets/img/icon-user.svg"
import search from "../../assets/img/icon-search.svg"
import add from "../../assets/img/icon-add.svg"
import trash from "../../assets/img/icon-trash.svg"

export default function User() {
  // const AllCanteenUsers = useSelector((state) => state?.APIResponse?.AllCanteenUsers)
  const UserTranslation = useSelector((state) => state.Translation.UserTranslation)

  // =============== Local States ===============
  const [userData, setUserData] = useState([])
  const [searchData, setSearchData] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [searchList, setSearchList] = useState([])
  const [searchTxt, setSearchTxt] = useState("")
  const [allUserProfile, setAllUserProfile] = useState({})

  const dispatch = useDispatch()

  const GetUserProfile = async (email) => {
    if (allUserProfile[email] === undefined) {
      setAllUserProfile((prev) => ({ ...prev, [email]: {} }))
      const response = await getCanteenUserProfile(email)
      setAllUserProfile((prev) => ({ ...prev, [email]: response }))
    }
  }

  const getCanteenUserData = async () => {
    setIsLoading(true)
    const response = await getCanteenUser()
    if (response?.Data && typeof response?.Data === "object" && response?.Data?.length >= 0) {
      dispatch(changeAllCanteenUsersValue(response?.Data))
      response?.Data?.map(async (d) => {
        GetUserProfile(d?.Email)
      })
      setUserData(response?.Data)
    } else {
      handleError(response)
    }

    setIsLoading(false)
  }

  const saveUser = async (name, email) => {
    const requestPayload = {
      Name: name,
      Email: email,
    }
    setSearchData(false)
    await saveCanteenUser(requestPayload).then((response) => {
      if (response) {
        setSearchTxt("")
        getCanteenUserData()
        toast.success(getDynamicLabel(UserTranslation?.msgSuccessUserAdd, "User added successfully."))
      } else {
        toast.error(getDynamicLabel(UserTranslation?.msgErrorUserAdd, "Error while adding user!"))
      }
    }).catch((error) => {
      handleError(error)
    })
  }

  const deleteUser = async (email) => {
    const resp = await deleteCanteenUser(email)
    await getCanteenUserData()
    if (resp === true) {
      toast.success(getDynamicLabel(UserTranslation?.msgSuccessUserRemove, "User removed successfully."))
    } else {
      toast.error(getDynamicLabel(UserTranslation?.msgErrorUserRemove, "Error while removing user!"))
    }
  }

  useEffect(() => {
    let subscribed = true

    if (searchTxt !== "") {
      searchColleague(searchTxt, moment().format("YYYY-MM-DD")).then(async (resp) => {
        if (subscribed) {
          if (resp?.length > 0) {
            setSearchData(true)
            resp?.map(async (d) => {
              GetUserProfile(d?.Email)
            })
            setSearchList(resp)
          } else {
            setSearchData(false)
            setSearchList([])
          }
        }
      })
    } else {
      if (subscribed) {
        setSearchData(false)
        getCanteenUserData()
      }
    }

    return () => {
      subscribed = false
    }
  }, [searchTxt])


  useEffect(() => {
    setIsLoading(true)
    getTranslationWithPageName(PAGE_NAME?.USERS, appName).then((response) => {
      if (typeof response === "object" && response?.length >= 0) {
        dispatch(changeUserTranslationValue(convertRespArrToLabelObject(response)))
      } else {
        handleError(response)
      }
    }).catch((error) => {
      handleError(error)
    }).finally(() => {
      setIsLoading(false)
    })
  }, [])

  return (
    <>
      <section className="section mb-4">
        <div className="inputSec-icon">
          <input
            value={searchTxt}
            onChange={(e) => setSearchTxt(e.target.value)}
            className="form-control mb-3"
            placeholder={getDynamicLabel(UserTranslation?.lblSearchUser, "Search User")}
          />
          <span><img src={search} alt="icon-search" /></span>
        </div>

        <div className="card">
          <div className="card-content">
            <div className="table-responsive table-custom">
              {isLoading && (
                <div className="d-flex align-items-center justify-content-center w-100" style={{ height: "500px" }}>
                  <ClipLoader
                    isLoading={isLoading}
                    size={50}
                    color="blue"
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                </div>
              )}

              <table className="table table-hover valignM list table-user mb-0">
                <tbody>
                  {!searchData && !isLoading && userData && userData?.length !== 0 && (
                    userData?.map((user, i) =>
                      <tr key={i}>
                        <td>
                          <div className="icon-md d-inline-block mt-2">
                            <img
                              src={allUserProfile[user?.Email] && allUserProfile[user?.Email]?.Image ? allUserProfile[user?.Email]?.Image : iconUser}
                              alt="Profile"
                              className="rounded-circle"
                            />
                          </div>
                        </td>
                        <td>
                          <div className="userInfo d-inline-block">
                            <span>{user?.Name}</span>
                            <span className="txt-sm txt-gray">{user?.Email}</span>
                          </div>
                        </td>
                        <td className="text-end">
                          <button className="btn btn-secondary btn-icon">
                            <img
                              alt="ico-trash" src={trash}
                              onClick={() =>
                                confirmAlert({
                                  title: getDynamicLabel(UserTranslation?.lblConfirmSubmit, "Confirm to submit"),
                                  message: getDynamicLabel(UserTranslation?.msgConfirmRemoveUser, "Are you sure you want to remove this user?"),
                                  buttons: [
                                    {
                                      label: getDynamicLabel(UserTranslation?.lblYes, "Yes"),
                                      onClick: () => deleteUser(user?.Id),
                                    },
                                    {
                                      label: getDynamicLabel(UserTranslation?.lblNo, "No"),
                                      onClick: () => { },
                                    },
                                  ],
                                })
                              }
                            />
                          </button>
                        </td>
                      </tr>
                    )
                  )}

                  {searchData && !isLoading && searchList && searchList?.length > 0 && (
                    searchList?.map((user, i) =>
                      <tr key={i}>
                        <td>
                          <div className="icon-md d-inline-block mt-2">
                            <img
                              src={allUserProfile[user?.Email] && allUserProfile[user?.Email]?.Image ? allUserProfile[user?.Email]?.Image : iconUser}
                              className="rounded-circle" alt="Profile"
                            />
                          </div>
                        </td>
                        <td>
                          <div className="userInfo d-inline-block">
                            <span>{user?.Name}</span>
                            <span className="txt-sm txt-gray">{user?.Email}</span>
                          </div>
                        </td>
                        <td className="text-end">
                          <button className="btn btn-secondary btn-icon">
                            <img
                              alt="icon-add"
                              src={add}
                              onClick={() => {
                                if (userData?.filter((data) => data?.Email === user?.Email)?.length > 0) {
                                  setSearchData(false)
                                  setSearchTxt("")
                                  toast.error(getDynamicLabel(UserTranslation?.msgWrnUserAlreadyExit, "User is already exist!"))
                                } else {
                                  confirmAlert({
                                    title: getDynamicLabel(UserTranslation?.lblConfirmSubmit, "Confirm to submit"),
                                    message: getDynamicLabel(UserTranslation?.msgConfirmAddUser, "Are you sure to add this user."),
                                    buttons: [
                                      {
                                        label: getDynamicLabel(UserTranslation?.lblYes, "Yes"),
                                        onClick: () =>
                                          saveUser(user?.Name, user?.Email),
                                      },
                                      {
                                        label: getDynamicLabel(UserTranslation?.lblNo, "No"),
                                        onClick: () => { },
                                      },
                                    ],
                                  })
                                }
                              }}
                            />
                          </button>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
